import React from "react";
import { useTranslation } from "react-i18next";
import { Account } from "@bn/api/apiv1";
import { Modal, ModalProps } from "@components";
import { DepotsSelectorBody } from "./DepotsSelectorBody";

type Props = {
  accounts?: Account[];
  onConfirm: (ids: number[]) => void;
  onSelect: (ids: number[]) => void;
  checkedPortfolios: number[];
} & Omit<ModalProps, "children">;

export const DepotsSelectorModal = ({
  accounts,
  checkedPortfolios = [],
  onSelect,
  onConfirm,
  onClose,
  ...rest
}: Props) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm(checkedPortfolios);
    onClose?.();
  };

  return (
    <Modal
      title={t("depotsSelect.title")}
      onClose={onClose}
      height="auto"
      disablePortal={false}
      {...rest}
    >
      <DepotsSelectorBody
        accounts={accounts}
        checkedPortfolios={checkedPortfolios}
        onSelect={onSelect}
        onConfirm={handleConfirm}
        onClose={onClose}
      />
    </Modal>
  );
};
